module.exports = __webpack_public_path__ + "static/img/10018 (2).503a06b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10018 (2).webp
// module id = aNAZ
// module chunks = 14